(function () {
    'use strict';

    angular.module("imApp").factory("productEansService", ['$ihttp', function ($ihttp) {
        let service = {
            listProductEans: function (parms) {
                return $ihttp.post({
                    method: 709,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
